import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyleSheet } from 'react-native';
import { theme } from '@xbto/design-system';
import { Col, Row } from '../../atoms';
import { BackButton } from '../../molecules';
export function NavBar({ children, onPressBack }) {
    return (_jsxs(Row.L, { style: $.container, children: [_jsx(Col.C, { style: $.back, children: _jsx(BackButton, { onPress: onPressBack }) }), _jsx(Row.LR, { style: $.content, children: children })] }));
}
const shared = {
    height: '100%',
    paddingHorizontal: theme.spacing['6'],
};
const $ = StyleSheet.create({
    container: {
        height: 64,
        borderColor: theme.color.border.primary,
        borderWidth: 1,
        borderTopWidth: 0,
        borderLeftWidth: 0,
    },
    back: Object.assign({}, shared),
    content: Object.assign(Object.assign({}, shared), { flex: 1, borderLeftColor: theme.color.border.primary, borderLeftWidth: 1 }),
});
